const { createElem } = require('./helperFunctions');

export default function streamBanner() {
  const useStreamDescriptionInBanner = () => {
    // Put stream title on banner
    const streamTitle = $('.description-block h1')[0].innerHTML;
    const streamDescription = $('.description-block p')[0].innerHTML;

    $('.primary-logo.txt').html(streamTitle);
    $('.header-intro h2').html(streamDescription);
  };

  const getBannerImages = () => {
    const bannerImages = window.onbrandData.bannerImages;

    for (const streamID in bannerImages) {
      if ($('body').hasClass('stream-' + streamID)) {
        $('.large-header').css('background-image', 'url("' + bannerImages[streamID] + '"');
      }
    }
  };

  const buildStreamBannerHtml = () => {
    const streamBanner = document.querySelector('#stream-banner-root');
    const streamLevel = document.body.classList.contains('listing-page');
    const itemLevel = document.body.classList.contains('single-page');
    const frag = document.createDocumentFragment();
    const pseudoHubPage = document.body.classList.contains('stream-5507522');

    if (!streamBanner && !pseudoHubPage) {
      const streamBanner = createElem('section', {
        id: 'stream-banner-root',
        class: 'stream-banner stream-banner-shorter',
      });
      const streamBannerContent = createElem('div', { class: 'stream-banner-content' });

      streamLevel ? streamBannerContent.classList.add('page-aligner') : '';

      if (itemLevel) {
        streamBannerContent.classList.add('page-width');
        streamBannerContent.classList.add('item-level');
      }

      streamBanner.appendChild(streamBannerContent);
      frag.appendChild(streamBanner);
    }

    return frag;
  };

  const moveStreamTitleAboveLogos = () => {
    const streamBannerContent = document.querySelector('.stream-banner-content');
    const streamDescBlock = document.querySelector('.page-aligner .description-block');
    const logos = document.querySelector('.stream-banner-logos-wrapper');
    const streamBanner = document.querySelector('#stream-banner-root');

    if (document.body.classList.contains('listing-page')) {
      if (streamDescBlock && logos) {
        streamBannerContent.insertBefore(streamDescBlock, logos);

        if (document.body.classList.contains('stream-5507522')) {
          const streamTitle = document.querySelector('meta[property="og:title"]').content;
          const streamDescription = streamDescBlock.querySelector('p');
          const hubHeading = createElem('h1', { class: 'hub-heading' }, streamTitle);
          streamDescBlock.insertBefore(hubHeading, streamDescription);
        }
      } else if (streamDescBlock && streamBanner) {
        streamBannerContent.appendChild(streamDescBlock);
      }
    } else if (document.body.classList.contains('single-page')) {
      const streamBreadcrumbName = document.querySelector('.uf-breadcrumb-stream').innerText;
      const descriptionBlock = createElem('div', { class: 'description-block' });
      const streamTitle = createElem('h1', { class: 'hub-heading' }, streamBreadcrumbName);

      descriptionBlock.appendChild(streamTitle);

      if (logos) {
        streamBannerContent.insertBefore(descriptionBlock, logos);
      } else if (streamBanner) {
        streamBannerContent.appendChild(descriptionBlock);
      }
    }
  };

  const moveStreamBannerIntoHeader = () => {
    const clientHeader = document.querySelector('#injected-header .full-header-hero-wrap');
    const streamBanner = document.querySelector('#top-header #stream-banner-root');
    const wavyBanner = document.querySelector('.hero.hero-type-');

    if (clientHeader && streamBanner) {
      const streamBannerContent = document.querySelector('.stream-banner-content');
      const itemLevel = document.body.classList.contains('single-page');
      const streamLevel = document.body.classList.contains('listing-page');

      clientHeader.insertBefore(streamBanner, wavyBanner);

      if (streamBannerContent) {
        streamLevel ? streamBannerContent.classList.add('page-aligner') : '';

        if (itemLevel) {
          streamBannerContent.classList.add('page-width');
          streamBannerContent.classList.add('item-level');
        }
      }

      moveStreamTitleAboveLogos();
    } else if (clientHeader && !streamBanner) {
      clientHeader.insertBefore(buildStreamBannerHtml(), wavyBanner);
      moveStreamTitleAboveLogos();
    } 
  };

  // if ($('body').hasClass('listing-page')) {
  //     // getBannerImages();
  //     // useStreamDescriptionInBanner();
  // }

  moveStreamBannerIntoHeader();
}



// WEBPACK FOOTER //
// ./scriptPartials/streamBanner.js